// Module
var code = `<div ng-init="selected = { tab: 0 }" class="schema-form-tabs row {{form.htmlClass}}">
    <div class="{{form.tabNavHtmlClass}}">
        <ul class="nav nav-tabs {{form.tabOrientation}}">
            <li ng-repeat="tab in form.tabs"
                ng-disabled="form.readonly"
                ng-click="\$event.preventDefault() || (selected.tab = \$index)"
                ng-class="{active: selected.tab === \$index}"
            >
                <a href="#">{{ tab.title }}</a>
            </li>
        </ul>
    </div>
    <div class="{{form.tabContentHtmlClass}} tab-content {{form.fieldHtmlClass}}">
    </div>
</div>`;
// Exports
module.exports = code;